import { ref } from 'vue'

/**
 * Lightweight global toast layer. Module-level singleton state so any component/composable can push a
 * transient message and the single <ToastNotification> mounted in App.vue renders them. RTL/Persian, dark-aware.
 */
const toasts = ref([])
let seq = 0

const DEFAULT_DURATION = 4500

function dismiss(id) {
  const i = toasts.value.findIndex((t) => t.id === id)
  if (i !== -1) toasts.value.splice(i, 1)
}

function showToast(message, type = 'info', duration = DEFAULT_DURATION) {
  // De-dupe an identical message that is already on screen (avoids spam on rapid repeated failures).
  if (toasts.value.some((t) => t.message === message && t.type === type)) return null
  const id = `t${++seq}_${Date.now()}`
  toasts.value.push({ id, message, type })
  if (duration > 0) setTimeout(() => dismiss(id), duration)
  return id
}

export function useToast() {
  return {
    toasts,
    showToast,
    dismiss,
    success: (m, d) => showToast(m, 'success', d),
    error: (m, d) => showToast(m, 'error', d),
    info: (m, d) => showToast(m, 'info', d),
  }
}
